/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DashboardProjectsControllerExportProjectContributorsV1$Params {
  projectId: string;

/**
 * Page number (1-based)
 */
  page?: number;

/**
 * Number of contributors per page
 */
  limit?: number;

/**
 * Only include contributors with at least this amount
 */
  minAmount?: number;

/**
 * Filter contributors by investment round
 */
  round?: 'private' | 'public';
}

export function dashboardProjectsControllerExportProjectContributorsV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerExportProjectContributorsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerExportProjectContributorsV1.PATH, 'get');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('minAmount', params.minAmount, {});
    rb.query('round', params.round, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/csv', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

dashboardProjectsControllerExportProjectContributorsV1.PATH = '/v1/dashboard/projects/{projectId}/contributors/export';
